module.exports = __webpack_public_path__ + "static/media/belcolor__6.563c6d68.jpg";